import React from 'react'

const JobPositionIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 50 50">
		<rect width="50" height="50" fill="#e6e7f3" rx="25" />
		<path
			fill="#030A7E"
			fillRule="evenodd"
			d="M33.905 35.594h2.392a.703.703 0 110 1.406H13.703a.703.703 0 010-1.406h2.402V23.703c0-.893.492-1.702 1.285-2.112l5.974-3.09v-1.4l-.746-.307a.703.703 0 11.534-1.3l.212.086v-.92l-.746-.306a.703.703 0 01.534-1.301l12.015 4.938a.703.703 0 11-.534 1.301l-.728-.3v.92l1.262.52a.703.703 0 01-.534 1.3l-.728-.299v14.16zm-1.407-17.18l-7.727-3.176v.92l7.727 3.176v-.92zm-11.357 17.18v-2.237a.703.703 0 00-1.406 0v2.236h-2.223v-4.35h2.926a.703.703 0 000-1.407h-2.926V28.66h2.926a.703.703 0 100-1.406h-2.926v-1.212h2.926a.703.703 0 100-1.406h-2.926v-.935c0-.364.2-.695.524-.862l5.329-2.756v15.51H21.14zm9.603-2.236v2.237h1.754V20.856l-7.727-3.176v17.915h1.754v-2.237a.703.703 0 011.406 0v2.237h1.406v-2.237a.703.703 0 011.407 0z"
			clipRule="evenodd"
		/>
	</svg>
)

export default JobPositionIcon
